import { SortOrder } from "@sinecycle/growcomponents";

const portalTabs = [
  "INVOICES",
  "PAYMENTS",
  "CREDIT_NOTES",
  "DISPUTES",
  "PTPs",
  "DOCUMENTS",
  "PROFILE",
] as const;
export type PORTAL_TABS = typeof portalTabs;
type PORTAL_TABS_LABEL = Record<PORTAL_TABS[number], string>;
type PORTAL_TABS_QUERY_KEYS = Record<PORTAL_TABS[number], string>;

export const portalTabsLabel: PORTAL_TABS_LABEL = {
  INVOICES: "Invoices",
  PAYMENTS: "Payments",
  CREDIT_NOTES: "Credit Notes",
  DISPUTES: "Disputes",
  PTPs: "PTPs",
  DOCUMENTS: "Documents",
  PROFILE: "Profile",
};

export const portalTabQueryKeys: PORTAL_TABS_QUERY_KEYS = {
  INVOICES: "invoice-list",
  PAYMENTS: "payment-list",
  CREDIT_NOTES: "credit-notes-list",
  DISPUTES: "dispute-list",
  PTPs: "ptp-list",
  DOCUMENTS: "document-lit",
  PROFILE: "profile-list",
};

export type Sorting = {
  sort_col: string;
  order: SortOrder;
};
